// extracted by mini-css-extract-plugin
module.exports = {"limitReportsIcon":"LimitReportsIcon_limitReportsIcon__h1Yeu"};